import { Component, OnInit} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { TranslateService } from '@ngx-translate/core';
import { Draggablemodal3Component } from '../draggablemodal3/draggablemodal3.component';
import { DatePipe } from '@angular/common';
import { Draggablemodal1Component } from '../draggablemodal1/draggablemodal1.component';
import { CheckExistingSessionComponent } from '../check-existing-session/check-existing-session.component';
declare var $: any;

@Component({
  selector: 'app-draggablemodal',
  templateUrl: './draggablemodal.component.html',
  styleUrls: ['./draggablemodal.component.scss']
})
export class DraggablemodalComponent implements OnInit { 
  public language: any;
  test2: any;
  public getDateFromstorage: any;
  public currentDate: any;
  public formattedDate: any;
  public storedVin: any;
  public currentVin: any;
  public tokenObjRes: any;
  constructor(
    public activeModal: NgbActiveModal, private modalService: NgbModal, public service: ApifirstService, public translate: TranslateService
    , public datePipe: DatePipe) { }

  ngOnInit() {
    this.test2 = this.translate.instant('YES');
    this.service.tokenObj.subscribe(data => {
      let c: any;
      c = data;
      this.language = c.language
      this.currentVin = c.vin;
    })
    $(document).ready(function () {
      let modalContent: any = $('.modal-content');
      modalContent.draggable({
        handle: '#full-width',
      });
    });
    if (!$(".modal.in").length) {
      $(".modal-dialog").css({
        top: 100,
        left: 0,
      });
    }
  }
  

  count = 0;
  oneDay: any;
  openModal1() {
    //  var localDate=localStorage.getItem("dateObj");
    // var date1 = new Date();
    // var hrs=date1.getHours();
    // var date2 = new Date();
    // var hrs1= date2.getHours() +24;

    //      console.log(date2, "date")

    //   var Time = date2.getTime() - date1.getTime();

    //   var Days = Time / (1000 * 3600 * 24);
    //   console.log(Days, "days")
    const payload = {
      vin: this.currentVin
    };
this.service.checkExistingMobileSession(payload).subscribe({ // Using object for subscribe for better error handling
  next: (response: any) => {
    if (response && response.hasExistingSession === true && response.sessionCount > 0) {
      // 1. Close THIS modal (DraggablemodalComponent) first
      this.activeModal.close(); // <--- CRUCIAL: Closes DraggablemodalComponent itself

      this.service.existingSessionData.next(response);
      const modalRef = this.modalService.open(CheckExistingSessionComponent, { backdrop: 'static' });

      // 3. Handle the result from CheckExistingSessionComponent
      modalRef.result.then((result) => {
        console.log('Result from CheckExistingSessionComponent:', result);
         if (result=== 'START_NEW') {
            // --- ORIGINAL DAYS LOGIC ---
             console.log('Result from info if:', result.action);
            this.storedVin = localStorage.getItem('VINnumber');
            this.getDateFromstorage = localStorage.getItem("setcustomerConcentDate");
            this.currentDate = new Date();
            this.formattedDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd hh:mm');
            var d1 = new Date(this.getDateFromstorage);
            var d2 = new Date(this.formattedDate);
            var Time = (d2.getTime() - d1.getTime());
            var Days = Math.round(Time / (1000 * 3600 * 24));
            if (Days > 0) {
              this.modalService.open(Draggablemodal3Component, { windowClass: "myCustomModalClass", backdrop: 'static' });
            } else {
              var arr = this.storedVin ? this.storedVin.split(",") : [];
              if (arr.includes(this.currentVin)) {
                this.modalService.open(Draggablemodal1Component, { windowClass: "myCustomModalClass", backdrop: 'static' });
              } else {
                this.modalService.open(Draggablemodal3Component, { windowClass: "myCustomModalClass", backdrop: 'static' });
              }
            }
          }
        // Based on the action, call the appropriate method in DraggablemodalComponent
       
      }, (reason) => {
        // Handle dismissal of CheckExistingSessionComponent (e.g., user clicked 'x' or backdrop)
        console.log('CheckExistingSessionComponent dismissed with reason:', reason);
        // You might want to re-open DraggablemodalComponent or handle this scenario appropriately.
        // For now, it's just logged.
      });
    } else {
      // If no existing session, still close DraggablemodalComponent
      this.activeModal.close(); // <--- CRUCIAL: Closes DraggablemodalComponent itself

      // --- ORIGINAL DAYS LOGIC (for no existing session) ---
      this.storedVin = localStorage.getItem('VINnumber');
      this.getDateFromstorage = localStorage.getItem("setcustomerConcentDate");
      this.currentDate = new Date();
      this.formattedDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd hh:mm');
      var d1 = new Date(this.getDateFromstorage);
      var d2 = new Date(this.formattedDate);
      var Time = (d2.getTime() - d1.getTime());
      var Days = Math.round(Time / (1000 * 3600 * 24));
      if (Days > 0) {
        this.modalService.open(Draggablemodal3Component, { windowClass: "myCustomModalClass", backdrop: 'static' });
      } else {
        var arr = this.storedVin ? this.storedVin.split(",") : [];
        if (arr.includes(this.currentVin)) {
          this.modalService.open(Draggablemodal1Component, { windowClass: "myCustomModalClass", backdrop: 'static' });
        } else {
          this.modalService.open(Draggablemodal3Component, { windowClass: "myCustomModalClass", backdrop: 'static' });
        }
      }
    }
  },
  error: (error) => {
    // API Error fallback for checkExistingMobileSession
    console.error('Error checking existing mobile session:', error);
    //this.isDisableStartDiagnosticBtn = false; // Assuming this property exists in DraggablemodalComponent
    // Also close DraggablemodalComponent if it's still open on error
    this.activeModal.close();
  }
});

 
  }


}
